'use client';

import { Dialog } from '@skin-seoul/design-system';

import { SkinSocietyBenefits } from '../SkinSocietyBenefits';

interface SkinSocietyBenefitsModalProps {
  isOpen: boolean;
  onClose: () => void;
  showBottomNav?: boolean;
  showSigninComment?: boolean;
}

export const SkinSocietyBenefitsModal = ({
  isOpen,
  onClose,
  showBottomNav = true,
  showSigninComment = false,
}: SkinSocietyBenefitsModalProps) => {
  const bottomMargin = showBottomNav ? '63px' : '0px';
  const maxContentHeight = showSigninComment ? '95dvh' : '80dvh';
  const maxBodyHeight = showBottomNav ? `calc(${maxContentHeight} - 63px)` : maxContentHeight;

  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => !e.open && onClose()}>
      <Dialog.Backdrop backgroundColor="rgba(0, 0, 0, 0.5)" backdropFilter="blur(2px)" zIndex={1650} />
      <Dialog.Positioner alignItems="flex-end" zIndex={1650}>
        <Dialog.Content
          width="100%"
          maxWidth="100vw"
          maxHeight={maxContentHeight}
          bg="transparent"
          borderTopRadius="20px"
          borderBottomRadius="0"
          mx={0}
          my={0}
          mb={bottomMargin}
          overflow="hidden"
        >
          <Dialog.Body
            p={4}
            pt={33}
            position="relative"
            zIndex={1}
            overflow="auto"
            bg="primary.900"
            maxHeight={maxBodyHeight}
          >
            <SkinSocietyBenefits showSigninComment={showSigninComment} />
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
